import {Button, Skeleton, Stack, Typography} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import InviteSomeoneForm from "src/components/account/InviteSomeoneForm";
import Box from "@mui/material/Box";
import {generatePath} from "react-router";
import useAuth from "src/hooks/use-auth";
import Link from '@mui/material/Link';
import {WhatsappIcon, WhatsappShareButton} from "react-share";
import Divider from "@mui/material/Divider";

const getReferralLink = referralCode => {
  const path = generatePath('/registreren');
  const location = window.location;

  return `${location.origin}${location.pathname}#${path}?meeneem-actie-code=${referralCode}`;
};

const InviteSomeonePage = () => {
  const { myUser } = useAuth();
  const [referralCode, setReferralCode] = useState('');

  useEffect(() => {
    if (myUser) {
      setReferralCode(myUser.referralCode)
    }
  }, [myUser]);

  const getReferralLinkElement = useCallback(() => {
    if (!referralCode) {
      return <Skeleton />;
    }

    const link = getReferralLink(referralCode);

    return <Link href={link}>{link}</Link>;
  }, [referralCode]);

  const referralLinkElement = useMemo(() => getReferralLinkElement(), [getReferralLinkElement]);
  const referralLink = useMemo(() => getReferralLink(referralCode), [referralCode]);

  useEffect(() => {
    console.log(document.cookie);
  }, []);

  return (
    <Stack>
      <Typography variant="h2" mb={2}>Iemand uitnodigen</Typography>

      <Typography>
        Via deze pagina kun je andere personen uitnodigen om bij ons in te schrijven als deelnemer.
        Je krijgt een vergoeding van 10 euro voor <u>elke</u> deelnemer die bij ons <b>OP LOCATIE</b> komt testen. Er is geen limiet voor het aantal personen dat je mag uitnodigen.
      </Typography>

      <Typography>
        Helaas is er op dit moment geen actie voor thuis testers.
      </Typography>

      <Typography>
        Vul hier de naam en het emailadres in van de persoon die u wilt uitnodigen. Deze persoon krijgt dan van ons een email met de uitnodiging en als hij/zij meedoet aan een test op onze locatie ontvangt u de bijbehorende vergoeding.
      </Typography>

      <Box mb={2}>
        <InviteSomeoneForm />
      </Box>

      { referralLinkElement &&
        <Stack spacing={2} mb={2}>
          <Box>
            <Typography component="span">
              Of deel direct de volgende registratielink: {referralLinkElement}
            </Typography>
          </Box>

          <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
            <Button variant="outlined" onClick={() => {navigator.clipboard.writeText(referralLink)}}>
              Link kopieëren
            </Button>

            <WhatsappShareButton
              url={`Hierbij nodig ik je uit om net als mij (of samen met mij) mee te doen met de smaaktesten van Sensoteam.nl. Als je wil deelnemen, klik dan op de volgende link en wanneer je bent geregistreerd kun je starten met testen! ${referralLink}`}
              style={{display: 'flex', alignItems: 'center'}}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography component="span">Delen via</Typography><WhatsappIcon size={32} />
              </Stack>
            </WhatsappShareButton>
          </Stack>
        </Stack>
      }

      <Typography component="span">Voorwaarden:</Typography>
      <ul>
        <li>Je verdient 10 euro extra voor elke deelnemer die bij ons op locatie komt testen (bijvoorbeeld Tilburg of Amsterdam).</li>
        <li>De vergoeding geldt alleen voor personen tussen de 18 en 67 jaar.</li>
        <li>De nieuwe deelnemer mag zichzelf registreren via het aanmeldformulier en vervolgens zelf een afspraak maken om bij ons te komen proeven.</li>
        <li>Zodra de persoon bij ons is komen testen, wordt jouw meeneem vergoeding toegevoegd aan je saldo.</li>
        <li>Je krijgt alleen betaald als de persoon ook ECHT aanwezig is geweest en als deze persoon nog NIET eerder bij ons is ingeschreven op de website.</li>
        <li>Er is geen maximum dus je mag zoveel mensen uitnodigen als je wil! En voor elke deelnemer ontvang je dus 10 euro.</li>
        <li>Belangrijk voor de deelnemer is dat hij/zij geen allergieën heeft voor de producten, bereid is verschillende producten te proeven en te beoordelen, de Nederlandse taal spreekt/schrijft én overweg kan met de computer. En natuurlijk krijgt de deelnemer ook gewoon de vergoeding voor de test waaraan hij/zij deelneemt.</li>
      </ul>
    </Stack>
  );
}

export default InviteSomeonePage